module.exports = __webpack_public_path__ + "static/media/Part 8.f7afa397.mp4";